import { render, staticRenderFns } from "./special.vue?vue&type=template&id=16c11b1f&scoped=true"
import script from "./special.vue?vue&type=script&lang=js"
export * from "./special.vue?vue&type=script&lang=js"
import style0 from "./special.vue?vue&type=style&index=0&id=16c11b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c11b1f",
  null
  
)

export default component.exports